module.exports = __webpack_public_path__ + "static/media/pencil-alt-solid~PDBpUNTg.99576dbd.svg";